<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Transfer Enrollment and Trends"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('transfer_enrollment_trends')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Transfer Enrollment
      and Trends (External) Tool.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support (External)
          <i class="fa-solid fa-arrow-right"></i> Transfer Enrollment and Trends
        </h1>

        <h3 class="h3-second-header">
          Initial results with default form values
        </h3>

        <ul class="unordered-list">
          <li>
            Once you get to the page, results will automatically generate based
            on the default values in the Transfer Enrollment and Trends form
            fields.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Goal for Transfer Enrollment and Trends tool
        </h3>

        <ul class="unordered-list">
          <li>
            Determine enrollment and graduation trends for transfer students.
          </li>
          <li>
            The charts display trends from cohort 2015 to 2023 for enrollment,
            retention and graduation rates.
          </li>
        </ul>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">
          Transfer Enrollment and Trends Form Submission
        </h3>

        <ol class="ordered-list">
          <li>Select type of admission</li>
          <li>Select associate degree</li>
          <li>Select full or part time status</li>
          <li>Select graduation time</li>
          <li>
            Lastly, you can also select the college, department and program
            which is optional
          </li>
        </ol>

        <div>
          <p></p>
          <img
            class="set-img-width-med"
            [(src)]="env['logo_paths']['helpPageTransferOverview59']"
            alt=""
          />
          <p class="picture-caption">
            Figure 59: Transfer Enrollment and Trends form fields
          </p>
        </div>
      </div>

      <div class="left-align-div">
        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageTransferOverview60']"
              alt=""
            />
            <p class="picture-caption">
              Figure 60: Enrollment Trends for Transfer Students graph
            </p>
          </div>

          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageTransferOverview61']"
              alt=""
            />
            <p class="picture-caption">
              Figure 61: Retention Trends and Graduation Rates graphs
            </p>
          </div>

          <div>
            <p></p>
            <img
              class="small-pics"
              [(src)]="env['logo_paths']['helpPageTransferOverview62']"
              alt=""
            />
            <p class="picture-caption">
              Figure 62: Filtered Transfer Student Data Table
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'Transfer Enrollment and Trends',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
